module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-group text-dark"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Temavisning")]), _vm._v(" "), _c('div', {
    staticClass: "choose-subject"
  }, [(_vm.isLoadingSubjects) ? _c('div', {
    staticClass: "choose-subject__spinner"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : _c('dSelect', {
    attrs: {
      "items": _vm.sortedSubjects,
      "receiveData": _vm.theNewSubject,
      "multiple": false,
      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
      "itemSpaceBetween": true
    },
    on: {
      "enter": _vm.onCreateNewSubject,
      "update": _vm.setSubject,
      "searchText": _vm.setTheSearchText,
      "onSearchTextDebounced": _vm.onSearchTextDebounced,
      "close": _vm.onCloseDSelect
    },
    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
      return {
        key: "test",
        fn: function(slotProps) {
          return [_c('div', {
            staticClass: "choose-subject__event_type"
          }, [_vm._v("\n          " + _vm._s(slotProps.item.vSubjectType) + "\n        ")])]
        }
      }
    })], null, true)
  }, [_vm._v(" "), _c('div', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_c('h4', {
    staticClass: "create-subject-link",
    on: {
      "click": _vm.onCreateNewSubject
    }
  }, [_vm._v("\n          + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n        ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
    }],
    staticClass: "icon__bg-circle create-new-subject",
    attrs: {
      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
    },
    on: {
      "click": _vm.onCreateNewSubject
    }
  }, [_c('span', {
    staticClass: "d-icon-plus"
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-583d95d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/ClassOnTrip/ClassOnTripSubject.vue
// module id = 1937
// module chunks = 1